import { createElementVNode as _createElementVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dw-cluster-popup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "dw-cluster-popup__anchor",
  width: "16",
  height: "8",
  viewBox: "0 0 16 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16 8L8 8L0 8L6.58579 1.41421C7.36684 0.633163 8.63316 0.633165 9.41421 1.41421L16 8Z",
    fill: "white"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_cluster_popup_selected_feature = _resolveComponent("dw-cluster-popup-selected-feature")!
  const _component_dw_cluster_popup_group = _resolveComponent("dw-cluster-popup-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.state.is_feature_selected)
      ? (_openBlock(), _createBlock(_component_dw_cluster_popup_selected_feature, {
          key: 0,
          feature: (_ctx.state.selected_feature as ClusterFeature<ClusterFeatureEntity>),
          "feature-index": (_ctx.state.selected_feature_index as number),
          "features-length": _ctx.features.length,
          onClose: _ctx.onClose,
          onOpenGroup: _ctx.deselectFeature,
          onSelectPrevious: _ctx.onSelectPrevious,
          onSelectNext: _ctx.onSelectNext,
          onChangeDate: _ctx.onChangeDate,
          onAddToWaitList: _ctx.onAddToWaitList,
          onAssign: _ctx.onAssign,
          onSelfDelivery: _ctx.onSelfDelivery
        }, null, 8, ["feature", "feature-index", "features-length", "onClose", "onOpenGroup", "onSelectPrevious", "onSelectNext", "onChangeDate", "onAddToWaitList", "onAssign", "onSelfDelivery"]))
      : (_openBlock(), _createBlock(_component_dw_cluster_popup_group, {
          key: 1,
          features: _ctx.features,
          "is-courier-item": _ctx.isCourierItem,
          onSelect: _ctx.selectFeature,
          onClose: _ctx.onClose
        }, null, 8, ["features", "is-courier-item", "onSelect", "onClose"]))
  ]))
}